// @hssna/ui-kit/common/LoadingSpinner — 加载指示器
// 规格: SPEC §6 / ADR-0012 (Tailwind) / OLD-01 (适老化)
//
// 支持 3 种尺寸 (sm/md/lg);适老化主题下自动放大

export type SpinnerSize = 'sm' | 'md' | 'lg';

export interface LoadingSpinnerProps {
  /** 尺寸 */
  readonly size?: SpinnerSize;
  /** 自定义类名 */
  readonly className?: string;
  /** 无障碍标签 */
  readonly label?: string;
}

const SIZE_CLASSES: Record<SpinnerSize, string> = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-10 h-10 border-4',
};

export function LoadingSpinner({
  size = 'md',
  className = '',
  label = '加载中',
}: LoadingSpinnerProps) {
  const classes = [
    // border-current + text-current: 继承父元素文本色, 便于在 Button 内适配 text-white
    'inline-block animate-spin rounded-full border-current border-t-transparent',
    SIZE_CLASSES[size],
    className,
  ].join(' ');

  return (
    <span
      role="status"
      aria-live="polite"
      aria-label={label}
      className={classes}
    />
  );
}
